var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.75V33.75M37.5 26.25V31.25M36.25 20C39.3109 20 40.9664 20.4685 41.7901 20.8318C41.8998 20.8802 41.9547 20.9044 42.113 21.0555C42.2079 21.146 42.3811 21.4117 42.4257 21.5351C42.5 21.7409 42.5 21.8534 42.5 22.0784V35.5139C42.5 36.6499 42.5 37.2179 42.3297 37.5098C42.1564 37.8068 41.9893 37.9449 41.6649 38.059C41.3461 38.1712 40.7025 38.0475 39.4152 37.8002C38.5142 37.6271 37.4457 37.5 36.25 37.5C32.5 37.5 28.75 40 23.75 40C20.6891 40 19.0336 39.5315 18.2099 39.1682C18.1002 39.1198 18.0453 39.0956 17.887 38.9445C17.7921 38.854 17.6189 38.5883 17.5743 38.4649C17.5 38.2591 17.5 38.1466 17.5 37.9216L17.5 24.4861C17.5 23.3501 17.5 22.7821 17.6703 22.4902C17.8436 22.1932 18.0107 22.0551 18.3351 21.941C18.6539 21.8288 19.2975 21.9525 20.5848 22.1998C21.4858 22.3729 22.5543 22.5 23.75 22.5C27.5 22.5 31.25 20 36.25 20ZM33.125 30C33.125 31.7259 31.7259 33.125 30 33.125C28.2741 33.125 26.875 31.7259 26.875 30C26.875 28.2741 28.2741 26.875 30 26.875C31.7259 26.875 33.125 28.2741 33.125 30Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF6);
export default __webpack_public_path__ + "static/media/f6.3bc98c9ab079308e9e50f89a53f78690.svg";
export { ForwardRef as ReactComponent };